import { render, staticRenderFns } from "./Gigly.vue?vue&type=template&id=0804ab4c&scoped=true&"
import script from "./Gigly.vue?vue&type=script&lang=js&"
export * from "./Gigly.vue?vue&type=script&lang=js&"
import style0 from "./Gigly.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Gigly.vue?vue&type=style&index=1&id=0804ab4c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0804ab4c",
  null
  
)

export default component.exports